import { FC, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { IProfessionalSchedulesAvailable } from "../api/getProfessionals";
import registerCheckout from "../api/registerCheckout";
import PageWrapper from "../components/common/PageWrapper";
import ProcedureSelector, { ProceduresType } from "../components/common/ProcedureSelector";
import ProfessionalProfile from "../components/common/ProfessionalProfile";
import FreeTimePicker from "../components/pickers/FreeTimePicker";
import { IProfessionalProfile, getProfessional } from "../api/getProfessional";

const AvailableTimesWrapper = styled.div`
	display: flex;
	flex-flow: column;
	min-height: 100vh;
	box-sizing: border-box;
`;

const ProfessionalProfileWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: normal;
`;

/**
 * ### Tela de horários disponiveis de um profissional
 * Mostra quais horários de um profissional estão diponiveis para agendamento
 * e permite que o usuário marque um agendamento nos que ele preferir.
 */
const AvailableTimesScreen: FC = () => {
	const [professional, setProfessional] = useState<IProfessionalProfile>();
	const [procedures, setProcedures] = useState<ProceduresType[]>();

	const { professionalId } = useParams<{ professionalId: string }>();
	const navigate = useNavigate();

	const handleAvailableSchedule = async (availableShedule: IProfessionalSchedulesAvailable) => {
		const response = await registerCheckout(availableShedule.idHorario);
		if (response && response.success === true) {
			navigate(`/medicos/${professionalId}/checkout/${response.id}?step=0`, { state: availableShedule });
		}
	};

	useLayoutEffect(() => {
		if (!professionalId) return;

		const getProfessionalData = async () => {
			const professionalResponse = await getProfessional(professionalId);

			setProfessional(professionalResponse);
			setProcedures(professionalResponse.procedimentos);
		};

		getProfessionalData();
	}, [professionalId]);

	return (
		<PageWrapper>
			<AvailableTimesWrapper>
				<ProfessionalProfileWrapper>
					<ProfessionalProfile professionalData={professional} codProfessional={professional ? professionalId : undefined} />
				</ProfessionalProfileWrapper>

				{/* MULTIPROCEDIMENTO */}
				{procedures && <ProcedureSelector procedures={procedures} />}

				{professionalId && <FreeTimePicker title="Horários disponíveis:" handleClick={handleAvailableSchedule} codProfessional={professionalId} />}
			</AvailableTimesWrapper>
		</PageWrapper>
	);
};

export default AvailableTimesScreen;
